import { CssBaseline } from "@mui/material";
import type { DateTime } from "luxon";
import type { FC } from "react";
// The screen renders above I18nProvider (the gate unmounts the whole app), so it initialises i18n itself.
import "@/i18n/i18n";
import { ThemePreferenceProvider } from "@/theme/ThemePreferenceProvider";
import { MaintenanceScreenBody } from "./MaintenanceScreenBody";

type MaintenanceScreenProps = {
	/** When planned maintenance is expected to end, or null when the notice gave no (valid) time. */
	endsAt: DateTime | null;
};

/**
 * The whole-screen notice shown while InHouse is down for planned maintenance. It sits
 * above every app provider, so it brings its own theme (the same provider + baseline as the hard force-update screen).
 */
export const MaintenanceScreen: FC<MaintenanceScreenProps> = ({ endsAt }) => (
	<ThemePreferenceProvider>
		<CssBaseline />
		<MaintenanceScreenBody endsAt={endsAt} />
	</ThemePreferenceProvider>
);
